import { render, staticRenderFns } from "./IconCommoMuted.vue?vue&type=template&id=0b26211a"
import script from "./IconCommoMuted.vue?vue&type=script&lang=js"
export * from "./IconCommoMuted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports